<template>
  <div>
    <ListItemFilters
      icon="ui-icon-disease"
      :title="doctorFiltersState.disease?.name || t('Что лечит врач', options)"
      :subtitle="doctorFiltersState.disease ? t('Заболевание', options) : ''"
      @click="openDialog"
    />

    <DiseaseModal
      :value="isDialogOpened"
      is-back
      :title="t('Что лечит врач', options)"
      :placeholder="t('Заболевание', options)"
      :page-type="pageType"
      :town-id="doctorFiltersState.visitLocation === 'online' ? undefined : commonStore.town.id"
      :speciality-id="doctorFiltersState.speciality.id"
      :selected-disease="filtersStore.unsavedFilters.disease"
      @disease:selected="onClickDisease"
      @disease:reset="onResetDisease"
      @input="handleCloseDiseaseModal"
    >
      <template #footer="{ selectedDisease }">
        <div class="pa-2 elevation-8">
          <v-btn
            block
            depressed
            color="primary"
            :disabled="!hasUnsavedDisease"
            @click="handleDiseaseSelected(selectedDisease)"
          >
            {{ t('Применить', options) }}
          </v-btn>
        </div>
      </template>
    </DiseaseModal>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import deepEqual from 'www/vue_components/common/TheFilters/doctors/functions/deepEqual'
import useCommonStore from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import DiseaseModal from 'www/vue_components/common/TheFilters/doctors/components/DiseaseFilters/components/DiseaseModal.vue'
import ListItemFilters from 'www/vue_components/common/TheFilters/common/components/ListItemFilters/ListItemFilters.vue'
import type { ApiDiseaseParamsGet } from 'www/vue_components/common/TheFilters/doctors/api/apiDiseases.types'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const commonStore = useCommonStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ListItemDisease')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: doctorFiltersState } = toRefs(props)

const hasUnsavedDisease = computed(() => (
  !deepEqual(doctorFiltersState.value.disease, filtersStore.unsavedFilters.disease)
))

const pageType = computed<ApiDiseaseParamsGet['page_type']>(() => {
  if (doctorFiltersState.value.visitLocation === 'online') {
    return 'online_doctor_list'
  }

  if (doctorFiltersState.value.visitLocation === 'home') {
    return 'house_doctor_list'
  }

  return 'town_doctor_list'
})

const handleDiseaseSelected = (disease: Filters['disease']) => {
  closeDialog()

  emit('input', {
    ...doctorFiltersState.value,
    disease,
  })
}

const handleCloseDiseaseModal = () => {
  closeDialog()
  filtersStore.updateUnsavedFilters(doctorFiltersState.value)
}

const onClickDisease = (disease: Filters['disease']) => {
  filtersStore.updateUnsavedFilters({ disease })
}

const onResetDisease = () => {
  filtersStore.updateUnsavedFilters({ disease: undefined })
  handleDiseaseSelected(undefined)
}
</script>
